export const SAVE_ALL_BOARDING_POINTS = 'SAVE_ALL_BOARDING_POINTS'